import { createContext, Dispatch, ReactElement, useContext, useReducer } from 'react'
import { ROW_MODE_COMPACT } from '@datasets/handsontable/read-grid/ReadGridConstants'
import { useDeepMemo } from '@global/hooks/useDeepMemo'
import { reducer } from './reducer'
import { State, Action } from './types'

const initialState: State = {
  bulkUploadModalIsOpen: false,
  bulkResubmitModalIsOpen: false,
  datasetDataId: null,
  selectedCells: {},
  selectedCell: null,
  selectedRows: {},
  selectiveEditModeEnabled: false,
  manualEdit: false,
  manualEditCanSubmitAll: true,
  manualEditLoading: false,
  selectiveEditDatasetsById: null,
  datasetTemplateId: null,
  removingRows: false,
  rowMode: ROW_MODE_COMPACT,
}

interface ContextValue extends State {
  dispatch: Dispatch<Action>
}

export const DatasetDataContext = createContext<ContextValue>({
  ...initialState,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  dispatch: () => {},
})

interface Props {
  children: ReactElement | ReactElement[]
}

export const DatasetDataContextProvider = ({ children }: Props) => {
  const [state, dispatch] = useReducer(reducer, initialState)

  // FIXME: Refactor state into a state key, instead of spread onto value.

  const value = useDeepMemo(() => ({ ...state, dispatch }), [state, dispatch])

  return <DatasetDataContext.Provider value={value}>{children}</DatasetDataContext.Provider>
}

export const useDatasetDataContext = () => {
  const context = useContext(DatasetDataContext)

  return context
}
